import React from "react";

const Loader = () => {
  return (
    <>
      <div className="flex space-x-2 justify-center items-center bg-card w-full min-h-[120px] h-full rounded-xl p-6">
        <span className="sr-only">Loading...</span>
        <div className="h-4 w-4 bg-primary rounded-full animate-bounce [animation-delay:-0.3s]"></div>
        <div className="h-4 w-4 bg-tertiary rounded-full animate-bounce [animation-delay:-0.15s]"></div>
        <div className="h-4 w-4 bg-accent rounded-full animate-bounce"></div>
      </div>
    </>
  );
};
export default Loader;
